import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login.vue'
import Home from '../components/Home.vue'
import User from '../components/user/User.vue'
import company from '../components/user/Company.vue'
import Role from '../components/user/Role.vue'
import Robot from '../components/robot/Robot.vue'
import WorkWarn from '../components/robot/WorkWarn.vue'
import MissionPlanning from '../components/robot/MissionPlanning.vue'
import ViewVideo from '../components/robot/ViewVideo.vue'
import AirWarn from '../components/robot/AirWarn.vue'
import Robotlog from '../components/robot/Robotlog.vue'
import Repair from '../components/robot/Repair.vue'
import Robotversion from '../components/robot/Robotversion.vue'
import Welcome from '../components/robot/Welcome.vue'
import dataMap from '../components/robot/DataMap.vue'
import taskMap from '../components/robot/TaskMap.vue'
import task from '../components/robot/Task.vue'
import temporary from '../components/robot/Temporary.vue'
import temporaryMap from '../components/robot/TemporaryMap.vue'
import robotManage from '../components/robot/RobotManage.vue'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/login', component: Login },
    { path:'/',redirect:'/login'},
    { 
      path: '/home',
      component: Home ,
      meta: {
        title: '机器人统一管理平台'
      },
      // //重定向到welcome页面
      // redirect:'/welcome',
      children:[
        //子页面
        {path: '/user',component: User},
        {path: '/robotversion',component: Robotversion},
        {path: '/viewVideo',component: ViewVideo},
        {path: '/repair',component: Repair},
        {path: '/robotlog',component: Robotlog},
        {path: '/airWarn',component: AirWarn},
        {path: '/role',component: Role},
        {path: '/robot',component: Robot},
        {path: '/workWarn',component: WorkWarn},
        {path: '/missionPlanning',component: MissionPlanning},
        {path: '/welcome',component: Welcome},
        {path: '/dataMap',component: dataMap},
        {path: '/taskMap',component: taskMap},
        {path: '/task',component: task},
        {path: '/temporary',component: temporary},
        {path: '/temporaryMap',component: temporaryMap},
        {path: '/robotManage',component: robotManage},
        {path: '/company',component: company},
      ]
  
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js